import { PageId } from 'constants/pages'

export const enum PageIdWoofzS2612 {
  DOG_BREED_S2_6_12 = PageId.DOG_BREED_S2_6_12,
  DOG_AGE_S2_6_12 = PageId.DOG_AGE_S2_6_12,
  SHELTER_S2_6_12 = PageId.SHELTER_S2_6_12,
  COMMANDS_S2_6_12 = PageId.COMMANDS_S2_6_12,
  SUBSCRIPTIONS_S2_6_12 = PageId.SUBSCRIPTIONS_S2_6_12,
  CHAT_UPSELL_S2_6_12 = PageId.CHAT_UPSELL_S2_6_12,
  UPSELL_1_S2_6_12 = PageId.UPSELL_1_S2_6_12,
  DOWNLOAD_S2_6_12 = PageId.DOWNLOAD_S2_6_12,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
